/* tslint:disable */

/**
 */
export class ViewMinMax {
    Message?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-min-max.ts